module.exports = __webpack_public_path__ + "1b0bad22befc16b567c5c824ababc6ef.MP3";